<div class="card main-product-card container-fluid p-4">
<div class="mb-3">
  <div class="row justify-content-between align-items-center">
    <div class="col-auto">
      <h3 class="m-0 font-bold text-muted">Mis Productos</h3>
    </div>
    <div class="col-auto d-flex gap-2">
      <p-button
        label="Volver"
        icon="pi pi-arrow-left"
        routerLink="/admin/my-store"
        severity="secondary"
        [rounded]="true"
        size="small"
      />
      <p-button
        label="Nuevo Producto"
        icon="pi pi-plus"
        severity="success"
        routerLink="/admin/my-store/products/create"
        [rounded]="true"
        size="small"
      />
    </div>
  </div>
</div>

<div class="row mb-3 g-2">
  <div class="col-12 col-md-6">
    <label for="categoryFilter" class="form-label">Filtrar por categoría:</label>
    <p-dropdown
      id="categoryFilter"
      [(ngModel)]="selectedCategoryFilter"
      [options]="categoryFilterOptions"
      optionLabel="label"
      optionValue="value"
      class="w-100"
    />
  </div>
  <div class="col-12 col-md-6">
    <label for="searchInput" class="form-label">Buscar por nombre:</label>
    <input
      id="searchInput"
      type="text"
      pInputText
      [(ngModel)]="searchText"
      placeholder="Buscar producto..."
      class="w-100"
    />
  </div>
</div>

<p-table [value]="filteredProducts" [loading]="loading" responsiveLayout="scroll">
  <ng-template pTemplate="header">
    <tr>
      <th>Miniatura</th>
      <th>Nombre</th>
      <th>Categoría</th>
      <th>Precio</th>
      <th>Disponible</th>
      <th>Destacado</th>
      <th>Acciones</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-product>
    <tr>
      <td>
        @if (product.pro_image_url) {
          <p-image
            [src]="product.pro_image_url"
            alt="Miniatura"
            width="44"
            height="44"
            imageClass="rounded border shadow-sm"
            [style]="{ 'object-fit': 'cover' }"
            [preview]="true"
          />
        } @else {
          <i class="pi pi-image text-muted" style="font-size: 1.5rem"></i>
        }
      </td>
      <td>{{ product.pro_name }}</td>
      <td>{{ getCategoryName(product.pro_category_id) }}</td>
      <td>${{ product.pro_price }}</td>
      <td>
        @if (product.pro_is_available) {
          <p-tag value="Disponible" severity="success" />
        } @else {
          <p-tag value="No disponible" severity="danger" />
        }
      </td>
      <td>
        <i
          class="pi"
          [ngClass]="product.pro_is_featured ? 'pi-star-fill' : 'pi-star'"
          [style.color]="product.pro_is_featured ? '#FFC107' : '#9CA3AF'"
        ></i>
      </td>
      <td>
        <p-button
          icon="pi pi-pencil"
          class="p-button-rounded p-button-text p-button-sm me-2"
          [routerLink]="['/admin/my-store/products/edit', product.pro_id]"
        />
        <p-button
          [icon]="product.pro_is_available ? 'pi pi-check' : 'pi pi-times'"
          class="p-button-rounded p-button-text p-button-sm"
          [ngClass]="{ 'p-button-success': product.pro_is_available, 'p-button-danger': !product.pro_is_available }"
          (onClick)="toggleAvailability(product)"
        />
      </td>
    </tr>
  </ng-template>
</p-table>

</div>

<p-toast position="bottom-right" />
